// extracted by mini-css-extract-plugin
export default {"main":"LinkButton_main__9vW1M","disabled":"LinkButton_disabled__dHGfp"};